import './preview-img.scss';
import React from 'react';

const PreviewImg = ({smallImgUrl, bigImgUrl, ps}) => {
    if (smallImgUrl) {
        return (
            <div className="preview-img">
                <span className="img-thumbnail" style={{backgroundImage:`url(${smallImgUrl})`}}/>
                {!ps.isMobileResponsive && <div className="big-img">
                    <img src={bigImgUrl}/>
                </div>}
            </div>
        );
    }

    return null;
};

export default PreviewImg;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/preview_img/PreviewImg.js